<div class="additional-arrow-button" (click)="handleClick($event)" [ngStyle]="getButtonStyle()">
    <span class="btn-text">{{BUTTON.ADD}}</span><br>
    <span class="btn-icon"><i class="pi pi-angle-double-right"></i></span>
</div>